// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Effect.bindEffect);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var jQueryEventWithSample = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var newEvent = Specular_FRP_Base.newEvent(MonadEffect0);
    var liftEffect = Effect_Class.liftEffect(MonadEffect0);
    var discard1 = discard(Bind1);
    var onCleanup = Control_Monad_Cleanup.onCleanup(MonadCleanup1);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (sample) {
        return function (eventType) {
            return function (node) {
                return bind(newEvent)(function (v) {
                    var handler = composeKleisli(sample)(v.fire);
                    return bind(liftEffect($foreign.addEventListener(eventType)(handler)($foreign.fromNode(node))))(function (unsub) {
                        return discard1(onCleanup(unsub))(function () {
                            return pure(v.event);
                        });
                    });
                });
            };
        };
    };
};
export {
    addEventListener,
    fromNode
} from "./foreign.js";
export {
    jQueryEventWithSample
};
